import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";
import { formatDate } from "../utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export const Months = [
  {
    prop: "January",
    name: "Enero",
    label: "Enero",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 1,
      mes2: "January"
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "February",
    name: "Febrero",
    label: "Febrero",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "March",
    name: "Marzo",
    label: "Marzo",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "April",
    name: "Abril",
    label: "Abril",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "May",
    name: "Mayo",
    label: "Mayo",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "June",
    name: "Junio",
    label: "Junio",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "July",
    name: "Julio",
    label: "Julio",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "August",
    name: "Agosto",
    label: "Agosto",
    minWidth: 80,
    fixed: true,
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperLinkColumn
  },
  {
    prop: "September",
    name: "Septiembre",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 90,
    fixed: true,
    formatter: HyperLinkColumn
  },
  {
    prop: "October",
    name: "Octubre",
    label: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    formatter: HyperLinkColumn
  },
  {
    prop: "November",
    name: "Noviembre",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    formatter: HyperLinkColumn
  },
  {
    prop: "December",
    name: "Diciembre",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 80,
    fixed: true,
    formatter: HyperLinkColumn
  },
  {
    prop: "Totals",
    name: "Total",
    label: "Total",
    minWidth: 80,
    fixed: true
  }
];

export const PaymentDetails = [
  // {
  //   prop: "EntryNo",
  //   label: "No. Registro",
  //   width: 130,
  //   sortable: true
  // },
  {
    prop: "DocumentNo",
    label: "Factura",
    Width: 100
  },
  {
    prop: "PostingDate",
    label: "Fecha Emisión Factura",
    Width: 170,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    Width: 200,
    formatter: ImagePerson
  },
  {
    prop: "AmountInDollars",
    label: "Monto",
    Width: 120
    // formatter: row => formatMonto(Number(row.Amount))
  },
  // {
  //   prop: "Contact",
  //   label: "Contacto",
  //   Width: 500,
  //   formatter: ImagePerson
  // },
  {
    prop: "Description",
    label: "Descripcion",
    Width: 230
  },
  {
    prop: "DueDate",
    label: "Fecha de vencimiento",
    width: 170,
    formatter: DatetimeFormatter
  },
  {
    prop: "PromiseDate",
    label: "Promesa de pago",
    Width: 140,
    formatter: DatetimeFormatter
  },
  {
    prop: "LatestComment",
    label: "Último Comentario",
    Width: 230
  }
  // {
  //   prop: "CreatedBy",
  //   label: "Usuario",
  //   minWidth: 350,
  //   formatter: ImagePerson
  // }
];

export const commentColumns = [
  {
    prop: "CreatorName",
    label: "Usuario",
    minWidth: 100,
    fixed: true
  },
  {
    prop: "CreatedOn",
    label: "Fecha",
    minWidth: 50,
    fixed: true,
    sortable: true,
    formatter: (row) => formatDate(row.CreatedOn, "DD/MM/yyyy")
  },
  {
    prop: "Description",
    label: "Comentario",
    minWidth: 200
  }
];

// export const MonthsAmount = [
//   {
//     prop: "January",
//     name: "Enero",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "February",
//     name: "Febrero",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "March",
//     name: "Marzo",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "April",
//     name: "Abril",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "May",
//     name: "Mayo",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "June",
//     name: "Junio",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "July",
//     name: "Julio",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "August",
//     name: "Agosto",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "September",
//     name: "Septiembre",
//     cellAtrrs: {
//       mes: 9
//     },
//     minWidth: 90,
//     fixed: true
//     //formatter: HyperLinkColumn
//   },
//   {
//     prop: "October",
//     name: "Octubre",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "November",
//     name: "Noviembre",
//     minWidth: 90,
//     fixed: true
//   },
//   {
//     prop: "December",
//     name: "Diciembre",
//     minWidth: 80,
//     fixed: true
//   },
//   {
//     prop: "Totals",
//     name: "Total",
//     minWidth: 80,
//     fixed: true
//   }
// ];
